import type { ReactElement } from 'react'
import markerRoundel from './assets/roundel-marker.svg'
import markerTail from './assets/marker-tail.svg'
import styles from './StationMarkerBubble.module.css'

interface Props {
  /** Anchor point in CSS pixels inside the preview — the station glyph. */
  x: number
  y: number
}

/**
 * "A" origin marker of the Overview map preview — Figma 8597:44610:
 * dark #1c1c1e rounded square holding the A-roundel, pointer tail
 * below, soft blue-tinted drop shadow. The tail tip anchors to the
 * station point; "A" mirrors the main map's route-origin bubble — the
 * click seeds this station as the route builder's From.
 */
export function StationMarkerBubble({ x, y }: Props): ReactElement {
  return (
    <div className={styles.marker} style={{ left: x, top: y }} aria-hidden="true">
      <div className={styles.bubble}>
        <img src={markerRoundel} alt="" className={styles.roundel} />
      </div>
      <img src={markerTail} alt="" className={styles.tail} />
    </div>
  )
}
